import { render, staticRenderFns } from "./RequestDetailsDialog.vue?vue&type=template&id=304bff83&lang=pug"
import script from "./RequestDetailsDialog.vue?vue&type=script&lang=js"
export * from "./RequestDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports